import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const screenReaderText = css`
    border: 0;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    word-wrap: normal !important;
`;

export const ScreenReaderText = styled.span`
    ${screenReaderText};
`;

export const setElementSpacing = (theme, property) => css`
    ${property}: ${theme.spacing.elementSpacingMobile};

    @media (min-width: ${theme.breakpoints.tabletLandscape}) {
        ${property}: ${theme.spacing.elementSpacingDesktop};
    }

    @media (min-width: ${theme.breakpoints.largeDesktop}) {
        ${property}: ${theme.spacing.elementSpacingWidescreen};
    }
`;

export const setMediumSpacing = (theme, property) => css`
    ${property}: ${theme.spacing.mediumSpacingMobile};

    @media (min-width: ${theme.breakpoints.tabletLandscape}) {
        ${property}: ${theme.spacing.mediumSpacingDesktop};
    }

    @media (min-width: ${theme.breakpoints.largeDesktop}) {
        ${property}: ${theme.spacing.mediumSpacingWidescreen};
    }
`;

export const setSectionSpacing = (theme, property) => css`
    ${property}: ${theme.spacing.sectionSpacingMobile};

    @media (min-width: ${theme.breakpoints.tabletLandscape}) {
        ${property}: ${theme.spacing.sectionSpacingDesktop};
    }

    @media (min-width: ${theme.breakpoints.largeDesktop}) {
        ${property}: ${theme.spacing.sectionSpacingWidescreen};
    }
`;

export const setSmallSpacing = (theme, property) => css`
    ${property}: ${theme.spacing.smallSpacingMobile};

    @media (min-width: ${theme.breakpoints.tabletLandscape}) {
        ${property}: ${theme.spacing.smallSpacingDesktop};
    }

    @media (min-width: ${theme.breakpoints.largeDesktop}) {
        ${property}: ${theme.spacing.smallSpacingWidescreen};
    }
`;

export const sectionSpacing = ({ theme }) => css`
    ${setSectionSpacing(theme, "margin-bottom")};
`;

export const mediumSpacing = ({ theme }) => css`
    ${setMediumSpacing(theme, "margin-bottom")};
`;

export const elementSpacing = ({ theme }) => css`
    ${setElementSpacing(theme, "margin-bottom")};
`;

export const smallSpacing = ({ theme }) => css`
    ${setSmallSpacing(theme, "margin-bottom")};
`;
